import { Action, ActionContext, default as Vuex, Module } from "vuex";
import AppSettings from "@/app-settings";

class CertificatesState {
  certInfo: any = {};
  certObject: any = undefined;
  getCertButtonState: string = "ready";
  setCertButtonState: string = "ready";
}

class CertificatesModule implements Module<CertificatesState, any> {
  namespaced = true;
  state: CertificatesState = new CertificatesState();
  mutations = {
    setCertificateInfo(state: CertificatesState, payload: any) {
      state.certInfo = payload;
    },
    setCertificateObject(state: CertificatesState, payload: any) {
      state.certObject = payload;
    }
  };
  actions = {
    async onConnectedToProxy(context: ActionContext<CertificatesState, any>) {
      //if we have certificate
      if (context.state.certObject) {
        context.state.setCertButtonState = "busy";
        //send cert to proxy
        try {
          await context.dispatch("getCertificateInfoProxy");
          await context.dispatch("setCertificateProxy");
          context.state.setCertButtonState = "success";
        }
        catch (err) {
          context.state.setCertButtonState = "error";
          throw Error("Could not set certificate on proxy: " + err);

        }
      }
    },
    //set certificate
    async setCertificateProxy(context: ActionContext<CertificatesState, any>) {
      try {
        context.state.setCertButtonState = "busy";
        const jwt = await context.dispatch("user/getOnlineIdToken", undefined, { root: true });

        const data = {
          cert: context.state.certObject.cert,
          key: context.state.certObject.key,
        };

        let address = context.rootState.settings.appSettings.hardwareServerAddress;
        let restfulPort = context.rootState.settings.appSettings.hardwareServerRestfulPort;
        let protocol = AppSettings.getHardwareRestfulProtocol(context.rootState.settings.appSettings);
        let response = await fetch(`${protocol}://${address}:${restfulPort}/certificateKeys`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + jwt,
          },
          body: JSON.stringify(data),
        });

        if (response.ok) {
          console.log("Certificate sent to proxy");
          context.state.setCertButtonState = "success";
          //   this.buttonState = "success";
        } else {
          let errorJson = await response.json();
          let s = "";
          for (let error of errorJson.errors) {
            s += `\n${error.message}`;
          }
          context.state.setCertButtonState = "error";
          throw Error("Response not ok: " + s);
        }
      } catch (err) {
        context.state.setCertButtonState = "error";
      }
    },
    //get certificate
    async getCertificateCloud(context: ActionContext<CertificatesState, any>) {
      context.state.getCertButtonState = "busy";
      const jwt = await context.dispatch("user/getOnlineIdToken", undefined, { root: true });

      let options: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json", Accept: "application/json", Authorization: "Bearer " + jwt },
      };

      try {
        let response = await fetch(context.rootGetters["urlCert"](), options);

        if (response.ok) {
          let json = await response.json();

          console.log("json received");
          console.log(json);
          let o = {
            "cert": json.cert,
            "key": json.key
          }
          context.commit("setCertificateObject", o);
          context.state.getCertButtonState = "success";
        } else {
          let errorJson = await response.json();
          let s = "";
          for (let error of errorJson.errors) {
            s += `\n${error.message}`;
          }
          context.state.getCertButtonState = "error";
          throw Error("Response not ok: " + s);
        }
      } catch (err) {
        console.error("Failed to fetch certificate:", err);
        context.state.getCertButtonState = "error";
      }
    },
    //get certificate info
    async getCertificateInfoProxy(context: ActionContext<CertificatesState, any>) {
      const jwt = await context.dispatch("user/getOnlineIdToken", undefined, { root: true });

      let address = context.rootState.settings.appSettings.hardwareServerAddress;
      let restfulPort = context.rootState.settings.appSettings.hardwareServerRestfulPort;
      let protocol = AppSettings.getHardwareRestfulProtocol(context.rootState.settings.appSettings);

      let response = await fetch(`${protocol}://${address}:${restfulPort}/certificateInfo`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + jwt,
        },

      });
      if (response.ok) {
        let json = await response.json();

        console.log(json);
        context.commit("setCertificateInfo", json);
      }
    }

  };
}

const certificatesModule: CertificatesModule = new CertificatesModule();
export default certificatesModule;
